import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import {
    ConsentDataStore,
    ConsentNotReceived,
    LoanAgreementContainer,
    SignatureDataStore,
} from '@servicetitan/financing-decision-shared';
import { CannotSignButtons, SignaturesFooter } from '../loan-agreement';

export const SignatureStep = () => {
    const { consentData } = ConsentDataStore.useStore();
    const esignConsentNotGiven =
        consentData.applicantConsent === false || consentData.coApplicantConsent === false;

    return esignConsentNotGiven ? <ConsentNotReceived /> : <LoanAgreementContainer />;
};

export const SignatureButtons = () => {
    const { signatureData } = SignatureDataStore.useStore();
    const { consentData } = ConsentDataStore.useStore();
    const esignConsentNotGiven =
        consentData.applicantConsent === false || consentData.coApplicantConsent === false;
    const cannotSign = signatureData.skipSignatureButtonClicked || esignConsentNotGiven;

    const { applicationData } = ApplicationDataStore.useStore();
    const hasCoApplicant = applicationData?.coApplicant?.hasCoApplicant ?? false;

    return cannotSign ? (
        <CannotSignButtons />
    ) : (
        <SignaturesFooter hasCoApplicant={hasCoApplicant} />
    );
};
